// React and related imports
import React, { useId } from 'react';

// Flowbite components
import { Label, Select } from 'flowbite-react';

// Types and Interfaces
import { PrayerName } from '../../../common/enums/PrayersName';

// Utils
import { localizePrayerName } from '../../../utils/localizePrayerName';

interface SelectPrayersNameProps {
  id?: string;
  label: string;
  placeholder: string;
  value: string;
  options: PrayerName[];
  onChange: (value: string) => void;
}

export const SelectPrayersName: React.FC<SelectPrayersNameProps> = ({
  id,
  label,
  placeholder,
  value,
  options,
  onChange,
}) => {
  const generatedId = useId();
  const effectiveID = id || generatedId;

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(event.target.value);
  };
  return (
    <div className="max-w-24">
      <div className="mb-2 block">
        <Label htmlFor={effectiveID}>
          {label}
          <span className="ms-1 text-red-500">*</span>
        </Label>
      </div>
      <Select
        id={effectiveID}
        value={value}
        onChange={handleChange}
        required
        className="block w-full rounded-md border-gray-300 text-sm focus:border-primary-500 focus:ring-primary-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:focus:border-primary-500 dark:focus:ring-primary-500"
      >
        {/* Conditionally render a placeholder option if value is empty */}
        {value === '' && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options.map((option, index) => (
          <option key={index} value={option}>
            {localizePrayerName(option)}
          </option>
        ))}
      </Select>
    </div>
  );
};
